import { createRef, useMemo, createElement } from "react";
import { Dropdown, DropdownTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useConfig } from "../../../contexts/config-context.js";
import { useForcedState, ForcedState } from "../../../contexts/forced-state-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { getMonthList } from "./helpers.js";
import { classes } from "./month-select-wut.st.css";
function MonthSelectWUT(props) {
  const { id, className, onChange, ...rest } = props;
  const { t } = useTranslation();
  const { isMobile, language } = useConfig();
  const dropdown = createRef();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const options = useMemo(
    () => getMonthList(language).map((month, index) => ({
      value: month,
      id: `${index + 1}`,
      isSelectable: true
    })),
    [language]
  );
  return /* @__PURE__ */ createElement(
    Dropdown,
    {
      ...rest,
      key: String(Boolean(props.value)),
      upgrade: true,
      ref: dropdown,
      newErrorMessage: true,
      mobileNativeSelect: isMobile,
      "aria-label": t("field.date.placeholder.month"),
      options,
      onChange: handleChange,
      initialSelectedId: props.value ? props.value.toString() : void 0,
      className: classNames(className, classes.root, classes.theme, {
        [classes.hover]: forcedHover,
        [classes.mobileDropdown]: isMobile
      }),
      theme: DropdownTheme.Box,
      flip: false
    }
  );
  function handleChange(option) {
    onChange?.(option.id);
    dropdown.current?.focus();
  }
}
export {
  MonthSelectWUT
};
//# sourceMappingURL=month-select-wut.js.map
